import React from 'react';
import Icon from '../../../components/AppIcon';

const ApplicationStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div 
        className="bg-white border-2 border-slate-200 rounded-lg p-4"
        style={{
          boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
        }}
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Users" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <p className="caption text-muted-foreground">Totaal</p>
            <p className="text-xl md:text-2xl font-semibold text-foreground">{stats?.total}</p>
          </div>
        </div>
      </div>
      <div 
        className="bg-white border-2 border-slate-200 rounded-lg p-4"
        style={{
          boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
        }}
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="Clock" size={20} color="var(--color-warning)" />
          </div>
          <div>
            <p className="caption text-muted-foreground">In Afwachting</p>
            <p className="text-xl md:text-2xl font-semibold text-foreground">{stats?.pending}</p>
          </div>
        </div>
      </div>
      <div 
        className="bg-white border-2 border-slate-200 rounded-lg p-4"
        style={{
          boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
        }}
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="CheckCircle" size={20} color="var(--color-success)" />
          </div>
          <div>
            <p className="caption text-muted-foreground">Geaccepteerd</p>
            <p className="text-xl md:text-2xl font-semibold text-foreground">{stats?.accepted}</p>
          </div>
        </div>
      </div>
      <div 
        className="bg-white border-2 border-slate-200 rounded-lg p-4"
        style={{
          boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
        }}
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="TrendingUp" size={20} color="var(--color-accent)" />
          </div>
          <div>
            <p className="caption text-muted-foreground">Gem. Match</p>
            <p className="text-xl md:text-2xl font-semibold text-foreground">{stats?.avgMatch}%</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationStats;